import { forwardRef } from 'react';

import PropTypes from 'prop-types';

import UIBox from './Box';

//@todo remove after material-ui Grid coverage all project
const LegacyBox = forwardRef(
  ({ children, justifyContent, justify, ...props }, ref) => {
    return (
      <UIBox justify={justify || justifyContent} {...props} ref={ref}>
        {children}
      </UIBox>
    );
  }
);

LegacyBox.propTypes = {
  /**
   * Make Box with relative position
   */
  relative: PropTypes.bool,

  /**
   * Make Box vertical
   */
  vertical: PropTypes.bool,

  /**
   * Margin for children
   */
  gutter: PropTypes.number,

  /**
   * Inline flex
   */
  inline: PropTypes.bool,

  /**
   * Shrink flex property
   */
  shrink: PropTypes.number,

  /**
   * Grow flex property
   */
  grow: PropTypes.number,

  /**
   * Order flex property
   */
  order: PropTypes.string,

  /**
   * Basis flex property
   */
  basis: PropTypes.string,

  /**
   * Reverse justify prop
   */
  reverse: PropTypes.string,

  /**
   * Wrap justify prop
   */
  wrap: PropTypes.oneOf(['wrap', 'nowrap', 'wrap-reverse']),

  /**
   * Flex justify-content prop
   * @see [justify-content MDN web docs](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content)
   */
  justify: PropTypes.oneOf([
    'center',
    'flex-start',
    'flex-end',
    'space-between',
    'space-around',
  ]),

  /**
   * Flex align-itmes prop
   * @see [align-items MDN web docs](https://developer.mozilla.org/en-US/docs/Web/CSS/align-items)
   */
  align: PropTypes.oneOf([
    'stretch',
    'center',
    'flex-start',
    'flex-end',
    'baseline',
    'initial',
    'inherit',
  ]),

  /**
   * Width
   */
  width: PropTypes.string,
};

export default LegacyBox;
